import {
  AddItemButton,
  ArrayInput,
  AutocompleteInput,
  Button,
  ReferenceInput,
  required,
  SimpleFormIterator,
  TextInput,
  useNotify,
  useRefresh,
} from "react-admin";
import PersonAddIcon from "@mui/icons-material/PersonAdd";
import { Grid } from "@mui/material";

import { settings } from "app";
import { administrationRequests } from "api/administrationApi";
import { studentRequests } from "api/studentApi";
import dataProvider from "server/dataProvider";
import FormModal from "server/components/Modals/FormModal";
import useConflictErrorModal from "server/components/Modals/useConflictErrorModal";
import { useNotifyError } from "utils/useNotifyError";

const isExamUpcoming = (examDate, examStartTime) => {
  if (!examDate || !examStartTime) return false;

  const [year, month, day] = examDate.split("T")[0].split("-").map(Number);
  const [hours, minutes] = examStartTime.split(":").map(Number);

  return new Date(year, month - 1, day, hours, minutes) > new Date();
};

const AddStudentsToSessionExamDialog = ({ sessionExamId, examDate, examStartTime }) => {
  const notify = useNotify();
  const notifyError = useNotifyError();
  const refresh = useRefresh();
  const { handleConflictError, ConflictErrorDialog } = useConflictErrorModal();

  const handleSubmit = async data => {
    const students = (data?.students ?? [])
      .filter(student => student?.specialityId && student?.facultyNumber)
      .map(student => ({
        specialityId: student.specialityId,
        facultyNumber: student.facultyNumber.trim(),
      }));

    if (students.length === 0) {
      notify("Моля, добавете поне един студент.", { type: "warning" });
      return false;
    }

    try {
      await dataProvider.customRequest(studentRequests.addStudentsToSessionExam(sessionExamId), { students }, "POST");
      notify("Студентите са добавени успешно към изпита", { type: "success" });
      refresh();
    } catch (error) {
      notifyError(error);
      handleConflictError(error);
      return false;
    }
  };

  if (!isExamUpcoming(examDate, examStartTime)) return null;

  return (
    <>
      <FormModal
        triggerButton={
          <Button
            label="Добави студенти"
            startIcon={<PersonAddIcon />}
          />
        }
        titleContent="Добавяне на студенти към изпит"
        onConfirm={handleSubmit}
        saveTitle="Запази"
        dialogSize="md"
      >
        <ArrayInput
          source="students"
          label=" "
          defaultValue={[{}]}
        >
          <SimpleFormIterator
            disableReordering
            disableClear
            inline
            addButton={<AddItemButton label="Добави студент" />}
            sx={settings.style.iteratorWithoutGap}
          >
            <Grid
              container
              spacing={2}
            >
              <Grid
                item
                xs={12}
                md={8}
              >
                <ReferenceInput
                  source="specialityId"
                  reference={administrationRequests.getSpecialitiesSelect()}
                >
                  <AutocompleteInput
                    label="Специалност"
                    optionValue="id"
                    optionText="name"
                    validate={[required()]}
                    filterToQuery={q => (q?.length > 2 ? { name: q } : {})}
                  />
                </ReferenceInput>
              </Grid>
              <Grid
                item
                xs={12}
                md={4}
              >
                <TextInput
                  source="facultyNumber"
                  label="Факултетен номер"
                  validate={[required()]}
                />
              </Grid>
            </Grid>
          </SimpleFormIterator>
        </ArrayInput>
      </FormModal>
      <ConflictErrorDialog />
    </>
  );
};

export default AddStudentsToSessionExamDialog;
